import React from 'react';
import Box from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import PrintIcon from '@mui/icons-material/Print';
import TimelineDot from '@mui/lab/TimelineDot';
import Typography from '@mui/material/Typography';
import i18next from 'i18next';

import { usePrinter, usePrinterSettings } from '~app/components/Print';
import { printerStatus } from '~app/components/Print/usePrinter';

function Printer() {
  const [printerSettings, setPrinterSettings] = usePrinterSettings();
  const { printers, connected, status, connect } = usePrinter();
  const connectedPrinter = printerSettings.printer
    ? printers.some((printer) => printer === printerSettings.printer)
    : true;
  const prevStatusInfo = !connectedPrinter ? 'warning' : 'success';
  const statusInfo = !connected ? 'error' : prevStatusInfo;

  return (
    <Box autoComplete="off">
      <Stack spacing={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <TimelineDot color={statusInfo} />
          <Typography>
            {` ${i18next.t(`Printer:${statusInfo}`, {
              printer: printerSettings.printer
            })}`}
          </Typography>
        </Stack>

        {!connected ? (
          <Button
            onClick={connect}
            size="small"
            variant="outlined"
            endIcon={<PrintIcon />}
            disabled={status === printerStatus.connecting}>
            Conectar
          </Button>
        ) : null}

        <TextField
          select
          label={i18next.t('Printer:printers')}
          helperText={i18next.t('Printer:printerHelperText')}
          onChange={(e) =>
            setPrinterSettings({
              ...printerSettings,
              printer: e.target.value
            })
          }
          value={printerSettings.printer}>
          {printers.map((printer) => (
            <MenuItem key={printer} value={printer}>
              {printer}
            </MenuItem>
          ))}
        </TextField>

        <FormGroup>
          <FormControlLabel
            name="enableAutoPrinting"
            onChange={(e) =>
              setPrinterSettings({
                ...printerSettings,
                enableAutoPrinting: e.target.checked
              })
            }
            control={<Switch defaultChecked checked={printerSettings.enableAutoPrinting} />}
            label={i18next.t('Printer:enable')}
            disabled={!printers.length}
          />
        </FormGroup>
      </Stack>
    </Box>
  );
}

export { Printer };
